import { IconButton, styled } from '@mui/material';

export const ArrowButtonWrap = styled(IconButton)(() => ({
	width: '32px',
	height: '32px',
	borderRadius: '5px',
	background: '#E3E9FE',
}));
